/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ContactDefs from './defs.defs'

const $nsid = 'app.bsky.contact.getSyncStatus'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  syncStatus: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ContactDefs.SyncStatus>(
      (() => ContactDefs.syncStatus) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Gets the user's current contact import status. Requires authentication. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, [
  'InvalidDid',
  'InternalError',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
